module.exports = __webpack_public_path__ + "media/application/images/svgs/image-5f04798f01c16470ad6178612ce4828c.svg";